// extracted by mini-css-extract-plugin
export default {"pageTitle":"roundPositionCell_pageTitle__IyxCv","roundPosition":"roundPositionCell_roundPosition__Y-Kyz"};